import { LocationQuery } from 'vue-router';
import { http } from '../helpers/axiosHelper';

export default class TeamsService {
   async getTeams(query: LocationQuery) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/team', {
            params: {
               ...query,
               include: 'tenant',
               per_page: 50,
            },
         })
         .then((response) => {
            return response.data;
         });
   }

   async createTeam(body: any) {
      return await http.post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/team', body).then((response) => {
         return response.data;
      });
   }

   async editTeam(id: Number, body: any) {
      return await http.put(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/team/' + id, body).then((response) => {
         return response.data;
      });
   }

   async getJourneyTeams() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-team/').then((response) => {
         return response.data;
      });
   }

   async addJourneyTeam(body: Object) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-team', body, { params: { include: 'team.tenant' } })
         .then((response) => {
            if (response.status) {
               return response.data;
            } else {
               throw Error('Kon team niet aanmaken');
            }
         })
         .catch((error) => {
            throw Error('Kon team niet aanmaken');
         });
   }

   async addJourneyTeams(body: Object) {
      return await http
         .post(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-team/bulk', body, { params: { include: 'team.tenant' } })
         .then((response) => {
            if (response.status) {
               return response.data;
            } else {
               throw Error('Kon teams niet aanmaken');
            }
         })
         .catch((error) => {
            throw Error('Kon teams niet aanmaken');
         });
   }

   async editJourneyTeam(body: Object, journeyTeamId: Number) {
      return await http
         .patch(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-team/' + journeyTeamId, body)
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            throw Error(error.response.data.value);
         });
   }

   async deleteJourneyTeam(journeyTeamId: Number) {
      return await http
         .delete(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/journey-team/' + journeyTeamId)
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            throw Error('Kon team niet verwijderen');
         });
   }
}
